export default "<h3>February 4, 2019</h3>\r\n<p>Update 0.73 fixes some bugs.</p>";